import Tooltip from '@mui/material/Tooltip';
import IconButton from 'components/@extended/IconButton';
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import { useTour } from 'contexts/TourContext';

// ==============================|| BOTÃO DE TOUR (AJUDA) — DENTRO DA PÁGINA ||============================== //
// Fica no topo do conteúdo da página (alinhado à direita), não no navbar.
// Renderiza null quando a tela não tem tour, sem ocupar espaço no layout.

export default function TourHelp() {
  const { hasTour, startTour } = useTour();

  if (!hasTour) return null;

  return (
    <Tooltip title="Tour desta tela">
      <IconButton
        color="secondary"
        variant="light"
        aria-label="iniciar tour da tela"
        onClick={() => startTour()}
        sx={{ alignSelf: 'flex-end', color: 'text.secondary', mt: -1, mb: -2 }}
      >
        <QuestionCircleOutlined />
      </IconButton>
    </Tooltip>
  );
}
